import { NgIf } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { HeaderComponent } from '@components/header/header.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule, Location } from '@angular/common'
import { Router } from '@angular/router';
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component';
import { LinkComponent } from '@components/link/link.component';
import { ApiService } from 'app/services/api.service';
import { ColumnConfig, ColumnFormat, TableComponent } from '@components/table/table.component';
import { TransactionData } from 'app/interfaces/transaction-data.interface';
import { PaginationComponent } from '@components/pagination/pagination.component';
import { EmployeeSummary } from 'app/interfaces/employee-summary.interface';

@Component({
    selector: 'app-mypoints',
    templateUrl: './employee-summary.component.html',
    styleUrl: './employee-summary.component.scss',
    standalone: true,
    imports: [HeaderComponent, TranslateModule, NgIf, ButtonComponent, CosentinoSvgComponent, LinkComponent, CommonModule, TableComponent, PaginationComponent],
})
export class EmployeeSummaryComponent {
    public currentPage: number = 0
    public totalPages: number = 0
    employeeSummaryColumns: ColumnConfig[] = [
        { key: 'name', header: this.translateService.instant('myrewards.employee') },
        { key: 'accountName', header: this.translateService.instant('myrewards.account') },
        { key: 'enabledGlobalRewards', header: this.translateService.instant('myrewards.able_to_redeem'), format: 'boolean' as ColumnFormat },
        { key: 'wonActios', header: this.translateService.instant('myrewards.generated_points'), format: 'number' as ColumnFormat },
        { key: 'redeemedActios', header: this.translateService.instant('myrewards.redeemed_points'), format: 'number' as ColumnFormat },
    ]

    public employeeSummaryData: EmployeeSummary[] = []

    constructor(private location: Location, private router: Router, private api: ApiService, private translateService: TranslateService) {}

    ngOnInit() {
        const userInfo = localStorage.getItem('weUserInfo')
        if (userInfo) {
            this.api.getPointsEmployeeSummary(this.currentPage).subscribe({
                next: (response) => {
                    this.employeeSummaryData = response.items
                    this.totalPages = response.totalPages
                },
                error: (error: any) => console.log(error),
            })
        }
    }
    onPageChange(page: number) {
        this.currentPage = page
        this.api.getPointsTransactions(page).subscribe({
            next: (response) => {
                this.employeeSummaryData = response.items
                this.totalPages = response.totalPages
            },
            error: (error: any) => console.log(error),
        })
    }
    goBack() {
        this.location.back()
    }
    goToMyPoints() {
        this.router.navigate(['/my-rewards'])
    }
}
